import { useUser } from '@clerk/clerk-react';

import { INTERNAL_TOOLS_EMAIL, isInternalToolsEmail } from '@momentum/types';

/**
 * Must match `INTERNAL_TOOLS_EMAIL` on the API, which enforces the same rule.
 * The override exists for local work as someone other than the team account;
 * setting it here without setting it there gives you a page whose every request
 * comes back 403.
 */
const ALLOWED_EMAIL =
  import.meta.env.VITE_INTERNAL_TOOLS_EMAIL ?? INTERNAL_TOOLS_EMAIL;

export interface InternalAccess {
  /** Clerk has resolved the user. Until then `isInternalUser` means nothing. */
  isLoaded: boolean;
  isInternalUser: boolean;
}

/**
 * Whether the signed-in user is the internal team account.
 *
 * This decides what to SHOW, never what to allow — the API refuses these routes
 * on its own, and has to, since nothing here can stop someone calling it
 * directly. Read it as "keep the door out of sight", not as the lock.
 */
export const useInternalAccess = (): InternalAccess => {
  const { isLoaded, user } = useUser();

  return {
    isLoaded,
    isInternalUser: isInternalToolsEmail(
      user?.primaryEmailAddress?.emailAddress,
      ALLOWED_EMAIL
    ),
  };
};
